<!-- 产品溯源 -->
<template>
	<div class="wrap">
		<div class="rightsidebar">
			<ul class="product-list">
				<li>
					<img src="../../assets/img-3.png" class="img">
				</li>
				<li>
					<img src="../../assets/img-3.png" class="img">
				</li>
				<li>
					<img src="../../assets/img-3.png" class="img">
				</li>
				<li>
					<img src="../../assets/img-3.png" class="img">
				</li>
				<li>
					<img src="../../assets/img-3.png" class="img">
				</li>
				<li>
					<img src="../../assets/img-3.png" class="img">
				</li>
			</ul>
			
		</div>
	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	import Footer from '../../components/footer.vue';
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
			};
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		margin: 0 !important;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.top {
		width: 1200px;
		height: 76px;
		line-height: 76px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 19px;
		box-sizing: border-box;
		color: #484848;
		font-size: 20px;
		margin: 20px 0;
	}

	.top-icon {
		width: 10px;
		margin: 0 10px;
	}

	.top-name {
		color: #F2501A;
	}

	.container {
		width: 1200px;
		display: flex;
		align-items: flex-start;
		margin-bottom: 43px;
	}

	.leftsidebar {
		width: 144px;
		padding: 21px 0 28px;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-right: 19px;
	}

	.leftsidebar>a {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
		padding: 0 0 0 29px;
		box-sizing: border-box;
		color: #000000;
		font-size: 16px;
		position: relative;
	}

	.leftsidebar>a.active {
		color: #F2501A;
		font-size: 18px;
	}

	.leftsidebar>a.active::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 4px;
		height: 26px;
		background: url(../../assets/border.png) no-repeat;
		background-size: 100% 100%;
	}

	.sanjiao {
		width: 14px;
		margin-left: 10px;
	}

	.rightsidebar {
		width: calc(100% - 0px);
		min-height: 774px;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 21px 24px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	
	.product-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin-top: 10px;
	}

	.product-list>li {
		width: 33.333%;
		display: flex;
	}

	.img{
		width: 100%;
		height: 261px;
		object-fit: cover;
	}
</style>
